
import SpacesBody from "../Componentjs/SpacesBody"
export default function Spaces(){
    return(
        <>
            <div>

                  <div>
                     <SpacesBody/>     
                  </div>


            </div>
        </>
    )
}